import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";

const API_URL = environment.apiUrl + 'fields/';

@Injectable({
  providedIn: 'root'
})
export class FieldService {

  constructor(
    private http: HttpClient
  ) { }

  getFields(integrationId: string) {
    return this.http.get(API_URL + integrationId, { responseType: 'json' });
  }

  getFieldMappings(integrationId: string, hubspotCustomerId: number) {
    return this.http.get(API_URL + integrationId + "/mapping?hubspotCustomerId=" + hubspotCustomerId, { responseType: 'json' });
  }

  createFields(integrationId: string, hubspotCustomerId: number, mapping: any) {
    const data = {
      customObjectMapping: mapping
    }
    return this.http.post(API_URL + integrationId + "/custom?hubspotCustomerId=" + hubspotCustomerId, data, { responseType: 'json' });
  }

  upsertFieldMappings(integrationId: string, hubspotCustomerId: number, fieldMappings: any) {
    return this.http.post(API_URL + integrationId + "/mapping?hubspotCustomerId=" + hubspotCustomerId, fieldMappings, { responseType: 'json' });
  }
}
